import { useMediaQuery } from '@abyss/web/hooks/useMediaQuery';
import { Divider } from '@abyss/web/ui/Divider';
import { Heading } from '@abyss/web/ui/Heading';
import { IconBrand } from '@abyss/web/ui/IconBrand';
import { Layout } from '@abyss/web/ui/Layout';
import { Link } from '@abyss/web/ui/Link';
import { Modal } from '@abyss/web/ui/Modal';
import { Text } from '@abyss/web/ui/Text';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { adobeLinkTrackEvent } from '../../../../common/AdobeTagging/adobeLinkTrackEvent';
import { phoneOnly } from '../../../../common/ConstantsStyles';
import { PSXIcon } from '../../../../common/PSXIcon';
import { StyledCloseButton } from './SharedAccessErrorModal.styled';

const SharedAccessErrorModal = () => {
  const mobileScreen = useMediaQuery(phoneOnly);
  const [isOpen, setIsOpen] = useState(true);

  const alignVal = mobileScreen ? 'left' : 'center';
  const { t } = useTranslation();

  function onClick(url, phone) {
    adobeLinkTrackEvent({
      name: `call ${phone}`,
      location: 'body: error modal',
      type: 'phone',
      destinationUrl: url,
    });
  }

  const onClose = () => {
    setIsOpen(false);
    window.location.href = window.location.origin;
  };

  return (
    <Modal
      closeOnClickOutside={false}
      closeOnEscPress={false}
      css={{
        '&.abyss-modal-body': {
          borderRadius: '8px',
          maxHeight: '100%',
        },
        'abyss-modal-header-container': {
          display: 'none',
        },
      }}
      data-auto-testid="shared-access-error-modal"
      data-testid="shared-access-error-modal"
      isOpen={isOpen}
      onClose={onClose}
      size={mobileScreen ? 320 : 624}
      /* Title is added to prevent JS error as the component required title prop, title is hidden adding css rules for abyss-modal-header-container */
      title={t('SHARED_ACCESS_ERROR_MODAL.HEADING')}
    >
      <Modal.Section
        css={{
          '&.abyss-modal-section-root': {
            padding: '16px 16px 12px',
          },
        }}
      >
        <Layout.Stack alignLayout="center" space={0}>
          <IconBrand brand="uhc" icon="alert" size={84} variant="twotone" />
        </Layout.Stack>
        <Layout.Stack alignItems={alignVal} alignLayout={alignVal} space={10}>
          <Heading
            color="$gray8"
            data-auto-testid="shared-access-error-modal-heading"
            data-testid="shared-access-error-modal-heading"
            display={'h5'}
          >
            {t('SHARED_ACCESS_ERROR_MODAL.HEADING')}
          </Heading>
          <Text
            color="$gray8"
            data-auto-testid="shared-access-error-modal-message"
            data-testid="shared-access-error-modal-message"
            size="md"
          >
            {t('SHARED_ACCESS_ERROR_MODAL.MESSAGE')}
          </Text>
        </Layout.Stack>
      </Modal.Section>
      <Modal.Section
        css={{
          '&.abyss-modal-section-root': {
            padding: '0 16px 16px',

            '@screen < $sm': {
              padding: '0 16px 12px',
            },
          },
        }}
      >
        <Layout.Stack alignLayout={alignVal} space={0}>
          <StyledCloseButton
            data-auto-testid="shared-access-error-modal-close-button"
            data-testid="shared-access-error-modal-close-button"
            onClick={onClose}
            size="$md"
          >
            {t('SHARED_ACCESS_ERROR_MODAL.CLOSE')}
          </StyledCloseButton>
        </Layout.Stack>
      </Modal.Section>
      <Divider height="1px" margin={0} />
      <Modal.Section
        css={{
          '&.abyss-modal-section-root': {
            padding: '16px 24px',

            '@screen < $sm': {
              padding: '12px 16px 16px',
            },
          },
        }}
      >
        <Layout.Stack alignItems="left" space={mobileScreen ? 10 : 16}>
          <Text
            color="$primary1"
            data-auto-testid="shared-access-error-modal-more-help"
            data-testid="shared-access-error-modal-more-help"
            fontWeight="bold"
            size="md"
          >
            {t('SHARED_ACCESS_ERROR_MODAL.MORE_HELP')}
          </Text>
          <Link
            before={<PSXIcon icon="call_us" size={20} />}
            data-auto-testid="shared-access-error-modal-call-us"
            data-testid="shared-access-error-modal-call-us"
            href={`tel:18778444999`}
            onClick={() => onClick(`tel: 18778444999`, '18778444999')}
            variant="outline"
          >
            {t('SHARED_ACCESS_ERROR_MODAL.CALL_US')}
          </Link>
        </Layout.Stack>
      </Modal.Section>
    </Modal>
  );
};
export default SharedAccessErrorModal;
